import { CheckCircleOutlineRounded, CloseRounded } from '@mui/icons-material';
import { Box, Button } from '@mui/material';

import { Container, Header } from './styles';

interface DrawerSuccessMensageProps {
  setOpenDrawerSuccessMensage: (type: boolean) => void;
  handleClose: () => void;
}

export const DrawerSuccessMensage = ({
  setOpenDrawerSuccessMensage,
  handleClose,
}: DrawerSuccessMensageProps) => {
  return (
    <Box width="480px" padding="20px">
      <Header>
        <CloseRounded
          sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
          onClick={() => setOpenDrawerSuccessMensage(false)}
        />
        <span className="title">Assinatura</span>
      </Header>
      <Box
        display="flex"
        alignItems="center"
        flexDirection="column"
        gap="10px"
        mt="50px"
      >
        <CheckCircleOutlineRounded
          color="success"
          sx={{ width: '66px', height: '66px' }}
        />
        <Container display="flex" flexDirection="column">
          <span className="title">Assinatura solicitada com sucesso!</span>
          <span className="desc">
            Os usuários serão solicitados para assinar o documento, e receberão
            um e-mail de notificação.
          </span>
        </Container>
        <Button
          variant="outlined"
          sx={{ marginTop: '20px' }}
          onClick={handleClose}
        >
          Ok, fechar
        </Button>
      </Box>
    </Box>
  );
};
